import { render, staticRenderFns, recyclableRender, components } from "./my-tabbar.vue?vue&type=template&id=c2722278&scoped=true&"
var renderjs
import script from "./my-tabbar.vue?vue&type=script&lang=js&"
export * from "./my-tabbar.vue?vue&type=script&lang=js&"
import style0 from "./my-tabbar.vue?vue&type=style&index=0&id=c2722278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2722278",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/my-tabbar/my-tabbar.vue"
export default component.exports